import { Theme } from '@easeltv/client-sdk';
import { createGlobalStyle } from 'styled-components';

/**
 * GlobalStyle
 *
 * Global style sheet for the Consumer Website
 * Uses a reset library (styled-reset) to iron out any inconsistencies between browser defaults
 */
export const GlobalStyle = createGlobalStyle<{ theme: Theme }>(
    ({ theme }) => `
        *, *:before, *:after {
           box-sizing: border-box;
        }

        html {
            box-sizing: border-box;
            font-family: "Open Sans", "Segoe UI", Tahoma, sans-serif;
            font-size: 16px;
            -webkit-text-size-adjust: 100%; /* Prevent font scaling in landscape while allowing user zoom */
        }

        body {
            background-color: ${theme.sections.page.background};
            overflow-x: hidden;
            --scrollbar-width: calc(100vw - 100%); // @TODO ^RP get this working for the carousel
        }

        :root {
            --font-size-a: 0.875rem;
            --font-size-b: 1.5rem;
            --font-size-c: 0.875rem;
            --font-size-d: 1.125rem;
            --font-size-e: 0.875rem;
            --font-size-f: 1.5rem;
            --font-size-g: 1rem;
            --font-size-h: 0.75rem;
            --font-size-i: 0.875rem;
            --font-size-j: 0.625rem;
            --font-size-k: 0.625rem;

            --page-element-x-padding: 1.2rem;

            @media (min-width: 48rem) {
                --font-size-a: 0.875rem;
                --font-size-b: 1.5rem;
                --font-size-c: 0.875rem;
                --font-size-d: 1.125rem;
                --font-size-e: 0.875rem;
                --font-size-f: 1.5rem;
                --font-size-g: 1rem;
                --font-size-h: 0.75rem;
                --font-size-i: 0.875rem;
                --font-size-j: 0.625rem;
                --font-size-k: 0.625rem;
            }

            @media screen and (min-width: 67.5rem) {
                --page-element-x-padding: 1.7rem;
            }

            @media screen and (min-width: 85rem) {
                --page-element-x-padding: 5.7rem;
            }

            @media (min-width: 105rem) {
                --font-size-a: 1rem;
                --font-size-b: 1.875rem;
                --font-size-c: 1.125rem;
                --font-size-d: 1.375rem;
                --font-size-e: 1.125rem;
                --font-size-f: 1.875em;
                --font-size-g: 1.25rem;
                --font-size-h: 1rem;
                --font-size-i: 1.125rem;
                --font-size-j: 0.75rem;
                --font-size-k: 0.75rem;
            }

            @media (min-width: 160rem) {
                --font-size-a: 1.5rem;
                --font-size-b: 2.625rem;
                --font-size-c: 1.625rem;
                --font-size-d: 2rem;
                --font-size-e: 1.625rem;
                --font-size-f: 2.625rem;
                --font-size-g: 1.875rem;
                --font-size-h: 1.375rem;
                --font-size-i: 1.625rem;
                --font-size-j: 1.125rem;
                --font-size-k: 1.125rem;
            }
          }
    `,
);
